"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _a;
/**
 * @hidden
 */
exports.labelsOptional = 'labels.optional';
/**
 * @hidden
 */
exports.messages = (_a = {},
    _a[exports.labelsOptional] = '(Optional)',
    _a);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-labels@3.18.0_@progress+kendo-react-intl@3.18.0_react-dom@16.14.0_react_nyscn3hbomdbkpk4tysqx62gaa/~/@progress/kendo-react-labels/dist/npm/messages/index.js
// module id = 346
// module chunks = 0